export default class Guid {

  public static empty() {
    return '00000000-0000-0000-0000-000000000000'
  }
}
